import { splitStreet } from '@/app/utils/loan/split-street'

export const DEFAULT_RESIDENCE_COUNTRY = 'FRANCE'

// Le back (`LoanQuoteUpdateService`) ne considère expatrié qu'un pays hors France ET hors territoires
// français (Corse, DROM-COM…) : ceux-ci restent `FRANCE` + `address_sub_area`, donc éligibles aux
// garanties IPT/ITT, IPP et Dos/Psy. Le champ « Lieu de résidence » porte le sous-territoire.
export function isExpatriateResidence(addressCountry: string, frenchTerritories: Array<{ FR: string }>): boolean {
    if (!addressCountry || addressCountry === DEFAULT_RESIDENCE_COUNTRY) return false

    return !frenchTerritories.some((territory) => territory.FR === addressCountry)
}

interface ResidenceProspectInfo {
    address_country?: string | null
    address_sub_area?: string | null
}

interface AddressFields {
    street: string
    zip_code: string
    city: string
}

// Le back stocke les DOM/TOM en pays FRANCE + sous-territoire, et attend le sous-territoire dans le champ pays.
export function resolveResidenceCountry(prospectInfo?: ResidenceProspectInfo | null): string {
    return prospectInfo?.address_sub_area || prospectInfo?.address_country || DEFAULT_RESIDENCE_COUNTRY
}

// Le pays de résidence pilote isExpat() côté back : une valeur par défaut ferait refuser l'import non-résident.
export function buildSubscriptionAddressPayload(
    address: AddressFields,
    prospectInfo?: ResidenceProspectInfo | null
) {
    // street_name est obligatoire chez l'assureur (champ Voie de l'import Utwin).
    const streetParts = splitStreet(address.street)

    return {
        street: address.street,
        street_number: streetParts.number,
        street_name: streetParts.name,
        zip_code: address.zip_code,
        city: address.city,
        country: resolveResidenceCountry(prospectInfo),
    }
}
